export default function CTA() {
  return (
    <section
      className="relative py-32 bg-cover bg-center bg-fixed"
      style={{
        backgroundImage:
          'url(https://techwholesale.it/_next/image?url=%2Fimages%2Fwarehouse-bg.jpg&w=1920&q=75)',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/85 via-gray-900/80 to-gray-900/85"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight tracking-wide uppercase">
          Inizia a Collaborare
          <span className="block text-orange-400">Con Noi</span>
        </h2>

        <p className="text-xl md:text-2xl text-white mb-12 font-light leading-relaxed">
          Richiedi il tuo account rivenditore
          <span className="block">e accedi a condizioni esclusive</span>
        </p>

        <a
          href="#contatti"
          className="inline-flex items-center space-x-4 bg-black text-white px-12 py-5 rounded-full text-lg font-bold hover:bg-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl hover:shadow-orange-500/50 hover:-translate-y-1 group"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-full group-hover:scale-110 transition-transform">
            <i className="ri-mail-line text-lg text-white"></i>
          </div>
          <span className="uppercase tracking-wide">Contattaci Ora</span>
          <i className="ri-arrow-right-up-line text-2xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}
